import { render, staticRenderFns } from "./ClientSelect.vue?vue&type=template&id=21373f7f&scoped=true"
import script from "./ClientSelect.vue?vue&type=script&lang=js"
export * from "./ClientSelect.vue?vue&type=script&lang=js"
import style0 from "./ClientSelect.vue?vue&type=style&index=0&id=21373f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21373f7f",
  null
  
)

export default component.exports